import axios from 'axios';
import { API_URL } from '../config/apiConfig';


// Get user's token
const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
};

// Get available affiliates for Stebby integration
export const getAffiliates = async () => {
    try {
        const response = await axios.get(`${API_URL}/stebby/affiliates`, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching affiliates:', error);
        throw error;
    }
};

// Find Stebby ticket by code and affiliate
export const findStebbyTicket = async (ticketCode, affiliateId) => {
    try {
        const response = await axios.post(`${API_URL}/stebby/find-ticket`, {
            ticketCode,
            affiliateId: parseInt(affiliateId)
        }, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error('Error finding Stebby ticket:', error);
        throw error;
    }
};

// Redeem Stebby ticket
export const redeemStebbyTicket = async (ticketCode, affiliateId, scheduledDate = null) => {
    try {
        const response = await axios.post(`${API_URL}/stebby/redeem-ticket`, {
            ticketCode,
            affiliateId: parseInt(affiliateId),
            scheduledDate
        }, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error('Error redeeming Stebby ticket:', error);
        throw error;
    }
};

// Get Stebby API key for affiliate
export const getStebbyApiKey = async (affiliateId) => {
    try {
        const response = await axios.get(`${API_URL}/stebby/api-key/${affiliateId}`, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching Stebby API key:', error);
        throw error;
    }
};

// Create or update Stebby API key
export const updateStebbyApiKey = async (affiliateId, stebbyId) => {
    try {
        const response = await axios.post(`${API_URL}/stebby/api-key/${affiliateId}`, {
            stebbyId
        }, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error('Error updating Stebby API key:', error);
        throw error;
    }
};

// Delete Stebby API key
export const deleteStebbyApiKey = async (affiliateId) => {
    try {
        const response = await axios.delete(`${API_URL}/stebby/api-key/${affiliateId}`, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting Stebby API key:', error);
        throw error;
    }
};